import { theme } from "@/core/theme";
import { PanelBoxV2 } from "@/tpo/Boxes";

export function ProfileWhiteCard({ children, gap = 40 }) {
  return (
    <PanelBoxV2 maxWidth={1020}>
      <PanelBoxV2
        maxWidth={760}
        outer={{
          pt: [30, 30, 60],
          pb: [50, 50, 80],
          bg: "white",
          borderRadius: 5,
          px: 20
        }}
        stacked
        gap={gap}
      >
        {children}
      </PanelBoxV2>
    </PanelBoxV2>
  );
}

export function ProfileHazeSection({ children, gap = 40 }) {
  return (
    <PanelBoxV2
      maxWidth={1532}
      outer={{
        pt: theme.spacing.section.pt,
        pb: theme.spacing.section.pb,
        px: [20],
        bg: "haze"
      }}
      stacked
      gap={gap}
    >
      {children}
    </PanelBoxV2>
  );
}

export default function ProfileSectionPanel({ children, gap = 40 }) {
  return (
    <ProfileHazeSection gap={gap}>
      <ProfileWhiteCard gap={gap}>{children}</ProfileWhiteCard>
    </ProfileHazeSection>
  );
}
